import { PrimeReactProvider } from "primereact/api";

import Router from "./Router";
import { useOnlineStatus } from "./hooks/useOnlineStatus";

import "./i18n";

const App = () => {
  // Monitor online/offline status and trigger error toast when offline
  useOnlineStatus();

  return (
    <PrimeReactProvider>
      <Router />
    </PrimeReactProvider>
  );
};

export default App;
